import { z } from "zod";

export const ErrorCodes = {
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  INVALID_INPUT: "INVALID_INPUT",
  RATE_LIMITED: "RATE_LIMITED",
  CSRF_INVALID: "CSRF_INVALID",
  CONFLICT: "CONFLICT",
  TOO_LARGE: "TOO_LARGE",
  INTERNAL: "INTERNAL",
} as const;

export const ApiErrorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;

export class ApiError extends Error {
  code: keyof typeof ErrorCodes;
  status: number;
  details?: unknown;

  constructor(
    code: keyof typeof ErrorCodes,
    message: string,
    status: number,
    details?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
    this.code = code;
    this.status = status;
    this.details = details;
  }

  toResponse(): Response {
    return Response.json(
      { error: { code: this.code, message: this.message, details: this.details } },
      { status: this.status },
    );
  }
}
